module.exports = __webpack_public_path__ + "static/media/tip_text_cat_flea_en.c50280b0.svg";